import { usePageMeta, PageHero } from "../components/Shared";
import { IMAGES, COMPANY } from "../data/site";

const CONTENT = {
  privacy: {
    title: "Privacy Policy",
    eyebrow: "Legal",
    body: [
      ["Overview", `${COMPANY.name} respects your privacy. This policy explains how we collect, use, and protect the information you provide through our website, in line with applicable Canadian privacy legislation (including PIPEDA).`],
      ["Information We Collect", "We collect information you submit through our quote and contact forms — such as your name, company, email, phone number, freight details, and any files you upload — so we can respond to your request and provide our services."],
      ["How We Use Your Information", "Your information is used only to respond to enquiries, prepare quotes, coordinate freight handling, and communicate with you. We do not sell your personal information."],
      ["Cookies & Analytics", "We use cookies to improve site performance and understand how visitors use our website. You can control cookies through your browser settings."],
      ["Data Retention & Security", "We retain submitted information only as long as necessary to serve you, and take reasonable measures to keep it secure."],
      ["Contact", `Questions about this policy can be directed to ${COMPANY.email}.`],
      ["Editable Placeholder", "This is a general template. Please review it with a legal professional and update it to reflect your exact data practices before publishing."],
    ],
  },
  terms: {
    title: "Terms & Conditions",
    eyebrow: "Legal",
    body: [
      ["Acceptance of Terms", `By accessing this website you agree to these terms. ${COMPANY.name} may update them at any time.`],
      ["Services", "Information on this site describes our logistics services in general terms. Specific service availability, timelines, and storage durations must be confirmed for each shipment."],
      ["Quotes & Requests", "Submitting a form does not create a binding contract. All engagements are subject to a confirmed agreement and availability."],
      ["Liability", "Our liability for freight handling is governed by the specific service agreement entered into with each customer."],
      ["Intellectual Property", `All content on this website is the property of ${COMPANY.name} unless otherwise noted.`],
      ["Governing Law", "These terms are governed by the laws of the Province of Ontario, Canada."],
      ["Editable Placeholder", "This is a general template. Please review it with a legal professional and update it before publishing."],
    ],
  },
};

export default function Legal({ kind }) {
  const c = CONTENT[kind];
  usePageMeta(c.title, `${c.title} for ${COMPANY.name}.`);
  return (
    <>
      <PageHero eyebrow={c.eyebrow} title={c.title} image={IMAGES.facility} />
      <div className="max-w-3xl mx-auto px-6 md:px-12 py-20 md:py-28 space-y-10">
        {c.body.map(([h, p]) => (
          <div key={h}>
            <h2 className="font-display font-bold text-2xl">{h}</h2>
            <p className="mt-3 text-text-secondary leading-relaxed">{p}</p>
          </div>
        ))}
      </div>
    </>
  );
}
